module.exports = __webpack_public_path__ + "img/mrxweb.7d644743.svg";